import { PLATFORMS } from '../utils/constants';
import { nuvemshopService as ncs } from './mobilizei/nuvemshop.service';
import { trayService as tcs } from './mobilizei/tray.service';
import { categoriesService as wcs } from './wix/categories.service';
import { categoriesService as ics } from './irroba/categories.service';
import { mapNuvemCategories } from '../utils/mappers/nuvemshop';
import { mapTrayCategories } from '../utils/mappers/tray';
import { mapWixCategories } from '../utils/mappers/wix';
import { mapIrrobaCategories } from '../utils/mappers/irroba'

export const categoriesServices = {
    getAllCategories
};

const PLATFORM_ORDER_FILTERS = {
    [PLATFORMS.TRAY]: { sort: 'order_asc' },
    [PLATFORMS.BAGY]: { sort: 'order_asc' },
    [PLATFORMS.IRROBA]: { sort: 'sort_order', order: 'ASC' },
    [PLATFORMS.NUVEMSHOP]: {},
    [PLATFORMS.WIX]: {}
};

function getAllCategories(platformId, storeId, accessToken, options = { filters: {} }) {
    let queryMethod = null;
    let mapperMethod = null;

    switch(platformId){
        case PLATFORMS.NUVEMSHOP:
            queryMethod = ncs.getAllCategories;
            mapperMethod = mapNuvemCategories;
            break;
        case PLATFORMS.BAGY:
        case PLATFORMS.TRAY:
            queryMethod = (storeId, page, categories, accessToken, options) => tcs.getAllCategories(platformId, storeId, options);
            mapperMethod = mapTrayCategories;
            break;
        case PLATFORMS.WIX:
            queryMethod = wcs.getAllCategories;
            mapperMethod = mapWixCategories;
            break;
        case PLATFORMS.IRROBA:
            queryMethod = ics.getAllCategories;
            mapperMethod = mapIrrobaCategories
            break;
        default:
            break;
    }

    const preserveOrder = !!options.preserveOrder;

    const queryOptions = {
        ...options,
        filters: {
            ...options.filters,
            ...(preserveOrder ? PLATFORM_ORDER_FILTERS[platformId] : {})
        }
    };

    const mapperOptions = platformId === PLATFORMS.WIX
        ? [[], { preserveOrder }]
        : [{ preserveOrder }];

    return queryMethod(storeId, 1, [], accessToken, queryOptions).then(response => {
        const categories = platformId === PLATFORMS.IRROBA
            ? mapperMethod(response.data, ...mapperOptions) : mapperMethod(response, ...mapperOptions);
        return categories;
    })
}